const getBrnTableConfig = (selectedBrn, onSelect) => {
  const type = "radio";
  return {
    columns: [{
      key: "refNumber",
      title: "BRN"
    }, {
      key: "companyName",
      title: "Company Name"
    }],
    rowSelection: {
      type,
      width: 50,
      defaultIdAttr: "refNumber",
      selectedRowIds: selectedBrn ? [selectedBrn] : void 0,
      onSelect: _ref => {
        let {
          record,
          selected
        } = _ref;
        return onSelect(record, selected);
      }
    }
  };
};
export { getBrnTableConfig };